<template>
    <form @submit.prevent="sign" class="simple-sign mt-4">
        <div v-if="isLocalhost" class="my-5">
            <h6>DEBUG</h6>
            <p>Item ID: {{itemId}}</p>
        </div>

        <p v-if="itemDescription" class="my-3">
          <small class="text-muted font-italic" v-html="itemDescriptionWithBr"></small>
        </p>

        <div class="custom-control custom-checkbox mb-4">
            <input :id="`${uuid}-confirm`" type="checkbox" class="custom-control-input" v-model="confirmed">
            <label class="custom-control-label" :for="`${uuid}-confirm`">{{ $t('sign.simple.consent') }}</label>
        </div>

        <div v-if="!authenticating">
            <button type="submit" class="signatureComponentSignButton btn btn-secondary mb-3" :disabled="!confirmed">
              <i class="fas fa-pen mr-1"></i> {{ signatureButtonLabel }}
            </button>
        </div>
        <button v-else type="button" class="signatureComponentSignButton btn btn-primary mt-3 wait">
            <i class="fas fa-pen mr-2"></i> <div class="spinner-border spinner-border-sm"></div>
        </button>
    </form>
</template>

<style lang="scss" scoped>
button {
    display: block;
    margin-left: auto;
    margin-right: auto;
    min-width: 50%;

    &.wait .spinner-border {
        vertical-align: middle;
    }
}
</style>

<script setup>
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { computed, ref } from "vue";

// Props should be in sync with bankIdSign.vue
const props = defineProps({
    itemId: { type: String, default: undefined },
    itemDescription: { type: String, default: undefined },
    appUrl: { type: String, default: undefined },
    redirectOnSignedUrl: { type: String, default: undefined },
    signeeName: { type: String, default: null },
    signatureButtonLabel: { type: String, default: undefined },
});
const emit = defineEmits(["signed"]);

const uuid = uuidv4();
const confirmed = ref(false);
const authenticating = ref(false);

const isLocalhost = computed(() => document.location.hostname === "localhost");
const itemDescriptionWithBr = computed(() =>
    props.itemDescription ? props.itemDescription.replaceAll("\n", "<br>") : null
);

async function sign() {
    try {
        authenticating.value = true;
        await axios.post("/simple_signatures", {
            item_id: props.itemId,
            item_description: props.itemDescription,
            confirmed: confirmed.value,
        });

        if (props.redirectOnSignedUrl) {
            window.location.replace(props.redirectOnSignedUrl);
        } else {
            emit("signed");
        }
    } catch (error) {
        authenticating.value = false;
        console.warn("Failed to store signature..", error);
    }
}
</script>
